mutation CanvasRegisterView($canvasId: ID!) {
  canvasRegisterView(canvasId: $canvasId) {
    success
  }
}
